import { useState } from "react";
import API from "../services/api";
import "./schoolAdminLogin.css";

export default function SchoolAdminLogin() {
  const [form, setForm] = useState({
    subdomain: "",
    email: "",
    password: ""
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await API.post("/school-admin/login/", form);
      localStorage.setItem("schoolAdmin", JSON.stringify(res.data));
      window.location.href = "/school-admin/dashboard";
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    }
  };

  return (
    <div className="school-admin-login-container">
      <div className="login-box">
        <h2>School Admin Login</h2>

        {error && <div className="error-box">{error}</div>}

        <form onSubmit={handleLogin}>

          <label>Subdomain</label>
          <input
            type="text"
            name="subdomain"
            placeholder="example (without .navith.cloud)"
            value={form.subdomain}
            onChange={handleChange}
          />

          <label>Admin Email</label>
          <input
            type="email"
            name="email"
            placeholder="admin@example.com"
            value={form.email}
            onChange={handleChange}
          />

          <label>Password</label>
          <input
            type="password"
            name="password"
            placeholder="******"
            value={form.password}
            onChange={handleChange}
          />

          <button type="submit" className="login-btn">Login</button>
        </form>
      </div>
    </div>
  );
}
